import Axios from "axios";

export const uploadDocument = (document) => {
    const formData = new FormData();
    formData.append("file", document);
    return Axios.post(`/api/retrocheck/document`, formData);
};

export const movePatientToMarketPlace = (patientData) => {
    return Axios.post(`/api/retrocheck/movepatienttomarketplace`, patientData);
};

export const getExportedToMarketplaceStatus = (mrn) =>{
    return Axios.get(`/api/retrocheck/marketplacestatus/${mrn}`);
}
export const setExportedToMarketplaceStatus = (mrn) =>{
    return Axios.post(`/api/retrocheck/movepatienttomarketplace/${mrn}`);
}